export default "__VITE_ASSET__BVeK_c17__"